import * as yup from 'yup';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[6-9]\d{9}$/; 

export const validationSchema = yup.object().shape({
  emailId: yup
    .string()
    .required('Email or Mobile number is required')
    .test(
      'email-or-mobile',
      'Enter a valid email or mobile number',
      value => {
        if (!value) return false;
        return emailRegex.test(value) || mobileRegex.test(value);
      }
    ),

  password: yup
    .string()
    .required('Password is required'),
});
